import setPopupSizes from "./product/setSizeGuide";
import setCarousel from "../components/carousel";
import setProductTabs from "./product/setProductTabs";
import setGallery from "./product/setGallery";
import { formMasks } from "../components/utilities";
import setTopBar from "../components/topBar";
import setRelatedModelsCarousel from "./product/relatedModelsCarousel";

const Product = {
  mainSlider: {
    element: document.querySelector("[data-main-slider]"),
    swiper: false,
  },
  thumbsSlider: {
    element: document.querySelector("[data-slider-thumbs]"),
    swiper: false,
  },
  sectionProduct: document.querySelector("[data-section-product]"),
  imagesWithoutSkus: [],
  thumbsWithoutSkus: [],
  imagesWithSkus: {},
  thumbsWithSkus: {},
  isZoomActive: false, // Estado inicial do zoom
  zoomAnimationFrame: null, // Variável para controlar `requestAnimationFrame` e evitar execuções desnecessárias

  setImages: function () {
    const mainProdId = window.mainProduct;
    const variants = window.productVariants[mainProdId];
    let skus = [];
    if (variants) skus = variants.map((variant) => variant.sku);

    Product.setImagesWithSkus(skus);
    Product.setImagesWithoutSkus();

    Product.sectionProduct.addEventListener("vnda:sku-change", (event) => {
      Product.updateImages(event.detail.sku);
      window.lazyLoad.init();
    });

    const sku = Product.sectionProduct.querySelector(
      '[data-product-purchase] [name="sku"]',
    ).value;
    Product.updateImages(sku);
    window.lazyLoad.init();
  },

  setImagesWithoutSkus: function () {
    const thumbsElement = Product.thumbsSlider.element;
    const mainElement = Product.mainSlider.element;

    if (thumbsElement)
      Product.thumbsWithoutSkus =
        thumbsElement.querySelectorAll("[data-without-sku]");
    if (mainElement)
      Product.imagesWithoutSkus =
        mainElement.querySelectorAll("[data-without-sku]");
  },

  setImagesWithSkus: function (skus) {
    const thumbsElement = Product.thumbsSlider.element;
    const mainElement = Product.mainSlider.element;

    const images = [
      ...thumbsElement.querySelectorAll("[data-with-sku]"),
      ...mainElement.querySelectorAll("[data-with-sku]"),
    ];

    skus.forEach((sku) => {
      Product.imagesWithSkus[sku] = [];
      Product.thumbsWithSkus[sku] = [];

      images.forEach((image) => {
        const imageSkus = image.getAttribute("data-skus").split(",");
        let type = "main";
        if (image.getAttribute("data-image-thumb") != null) type = "thumb";

        if (imageSkus.includes(sku)) {
          type === "main"
            ? Product.imagesWithSkus[sku].push(image)
            : Product.thumbsWithSkus[sku].push(image);
        }
      });
    });
  },

  updateImages: function (sku) {
    const thumbs = Product.thumbsSlider.swiper;
    const main = Product.mainSlider.swiper;
    const skuThumbs = Product.thumbsWithSkus[sku];
    const skuImages = Product.imagesWithSkus[sku];

    thumbs.removeAllSlides();
    thumbs.appendSlide(Product.thumbsWithoutSkus);
    if (skuThumbs) thumbs.appendSlide(skuThumbs);

    main.removeAllSlides();
    main.appendSlide(Product.imagesWithoutSkus);
    if (skuImages) main.appendSlide(skuImages);

    thumbs.update();
    main.update();
    main.thumbs.update();

    thumbs.slideTo(0);
    main.slideTo(0);
  },

  // Controla o estado do zoom, eventos de mudança e movimento do mouse
  setZoomControl: function () {
    const { handleMouseMoveZoom } = Product;
    const gallery = Product.mainSlider.swiper;
    if (!gallery) return; // Sai se o Swiper não estiver inicializado

    // Altera a qualidade da imagem ao aplicar zoom
    gallery.on("zoomChange", (swiper, scale, imageEl, slideEl) => {
      Product.handleZoomImageSources(slideEl);
    });

    // Remove o zoom ao trocar de slide manualmente
    gallery.on("slideChangeTransitionEnd", () => {
      gallery.zoom.out();
      gallery.slides.forEach((slide) => slide.classList.remove("-zoomed"));
      Product.isZoomActive = false;
    });

    // Acompanha o movimento do mouse para mover a imagem ampliada - somente desktop
    !window.mobile &&
      gallery.slides.length > 0 &&
      gallery.slides.forEach((slide) => {
        slide.addEventListener("mousemove", (event) => {
          if (slide.classList.contains("-zoomed") && Product.isZoomActive) {
            const zoomContainer = slide.querySelector(".swiper-zoom-container");
            const zoomedImage = slide.querySelector(".swiper-zoom-target");
            if (!zoomContainer || !zoomedImage) return;

            handleMouseMoveZoom(event, zoomContainer, zoomedImage);
          }
        });

        // Ativa/desativa o zoom com clique em sliders de 1 slide por vez
        // if (gallery.params.slidesPerView === 1) {
        //   Product.mainSlider.element.classList.add('-single-click');
        //   slide.addEventListener('click', () => {
        //     if (slide.classList.contains('-zoomed')) {
        //       gallery.zoom.out();
        //       gallery.slides.forEach((s) => s.classList.remove('-zoomed'));
        //       Product.isZoomActive = false;
        //     } else if (!Product.isZoomActive) {
        //       gallery.zoom.in();
        //       slide.classList.add('-zoomed');
        //       Product.isZoomActive = true;
        //     }
        //   });
        // }
      });
  },

  // Ativa o zoom e atualiza slide/thumb ao passar o mouse sobre a imagem
  setHoverZoom: function () {
    const gallery = Product.mainSlider.swiper;
    const mainImagesContainer = document.querySelector("[data-main-slider]");
    const thumbsContainer = document.querySelector("[data-slider-thumbs]");
    if (!gallery || !mainImagesContainer || !thumbsContainer) return;

    const thumbs = thumbsContainer.querySelectorAll(".swiper-slide");
    const productImages = mainImagesContainer.querySelectorAll("[data-image]");

    // Configura zoom no hover apenas em Desktop (> 991px)
    if (window.innerWidth > 991) {
      productImages.forEach((image, index) => {
        image.addEventListener("mouseenter", () => {
          if (!Product.isZoomActive) {
            gallery.slideTo(index); // Move para o slide hovered
            gallery.zoom.in();
            image.classList.add("-zoomed");
            Product.isZoomActive = true;

            // Atualiza a thumb ativa
            thumbs.forEach((el) => el.classList.remove("-active"));
            thumbs[index]?.classList.add("-active");
          }
        });

        image.addEventListener("mouseleave", () => {
          if (Product.isZoomActive) {
            gallery.zoom.out();
            image.classList.remove("-zoomed");
            Product.isZoomActive = false;
          }
        });
      });
    }
  },

  handleMouseMoveZoom: function (event, imgContainer, zoomedImage) {
    if (Product.zoomAnimationFrame) return; // Se houver uma animação pendente, sai da função

    Product.zoomAnimationFrame = requestAnimationFrame(() => {
      const rect = imgContainer.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      const percentX = (mouseX / rect.width) * 100;
      const percentY = (mouseY / rect.height) * 100;

      // Define a origem do zoom de acordo com a posição do mouse
      zoomedImage.style.transformOrigin = `${percentX}% ${percentY}%`;

      Product.zoomAnimationFrame = null; // Libera a próxima execução do requestAnimationFrame
    });
  },

  // Controla as thumbs: clique para scroll e atualização por visibilidade
  setThumbsControl: function () {
    const gallery = Product.mainSlider.swiper;
    const mainImagesContainer = document.querySelector("[data-main-slider]");
    const thumbsContainer = document.querySelector("[data-slider-thumbs]");
    const header = document.querySelector("header");
    if (!gallery || !mainImagesContainer || !thumbsContainer || !header) return;

    const thumbs = thumbsContainer.querySelectorAll(".swiper-slide");
    const productImages = mainImagesContainer.querySelectorAll("[data-image]");

    // Observa a visibilidade das imagens para atualizar a thumb ativa
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !Product.isZoomActive) {
            const index = Array.from(productImages).indexOf(entry.target);
            if (index !== -1) {
              gallery.slideTo(index); // Move para o slide visível
              thumbs.forEach((el) => el.classList.remove("-active"));
              thumbs[index]?.classList.add("-active");
            }
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0.5 }, // 50% de visibilidade
    );

    productImages.forEach((image) => observer.observe(image));

    // Configura o clique nas thumbs para rolar até o slide correspondente
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const relativeSlide = thumb.getAttribute("data-image-index");
        if (relativeSlide) {
          const elementToScroll = mainImagesContainer.querySelector(
            `#${relativeSlide}`,
          );
          if (elementToScroll) {
            window.scroll({
              top:
                elementToScroll.getBoundingClientRect().top +
                window.scrollY -
                header.offsetHeight,
              behavior: "smooth",
            });
            const index = Array.from(thumbs).indexOf(thumb);
            gallery.slideTo(index); // Move para o slide clicado
            thumbs.forEach((el) => el.classList.remove("-active"));
            thumb.classList.add("-active");
          }
        }
      });
    });

    // Define a primeira thumb como ativa por padrão
    thumbs[0] && thumbs[0].classList.add("-active");
  },

  handleZoomImageSources: function (slide) {
    const image = slide.querySelector("img");
    if (!image || !image.getAttribute("data-zoom-src")) return;

    const zoomUrl = image.getAttribute("data-zoom-src");
    if (slide.classList.contains("-zoomed")) {
      image.src = zoomUrl;
      image.removeAttribute("srcset");
      image.removeAttribute("data-srcset");
      image.removeAttribute("data-zoom-src");
      Product.mainSlider.swiper.update();
    }
  },

  handleImagesPopup: function () {
    const { mainSlider, handleMouseMoveZoom } = Product;
    const mainImages = mainSlider.element.querySelectorAll("img");
    if (mainImages.length === 0) return;

    let popup = document.createElement("div");
    popup.id = "image-popup";

    let closeButton = document.createElement("button");
    closeButton.innerText = "X";
    closeButton.classList.add("close-button");

    let imgContainer = document.createElement("div");
    imgContainer.classList.add("image", "-custom", "-loading");

    let zoomedImage = document.createElement("img");
    zoomedImage.classList.add("popup-image");

    popup.appendChild(imgContainer);
    popup.appendChild(closeButton);
    imgContainer.appendChild(zoomedImage);

    let isZoomed = false;
    let scaleFactor = 1;

    // Fecha o popup (clique no botão ou no background)
    popup.addEventListener("click", (event) => {
      if (event.target === popup || event.target === closeButton) {
        popup.classList.remove("-visible");
        isZoomed = false;
        zoomedImage.style.transform = "scale(1)";
        zoomedImage.style.transformOrigin = "center";
      }
    });

    mainImages.forEach((image) => {
      image.addEventListener("click", () => {
        imgContainer.classList.add("-loading");

        zoomedImage.src = image.getAttribute("data-zoom-src") || image.src;
        zoomedImage.alt = image.alt;
        zoomedImage.onload = () => {
          imgContainer.classList.remove("-loading");
        };

        if (!document.body.contains(popup)) document.body.appendChild(popup);
        setTimeout(() => popup.classList.add("-visible"), 50);
      });
    });

    // Ativa o segundo nível de zoom ao clicar na imagem dentro do popup
    zoomedImage.addEventListener("click", (event) => {
      event.stopPropagation();

      if (!isZoomed) {
        scaleFactor = 1.5;
        zoomedImage.style.transform = `scale(${scaleFactor})`;
        zoomedImage.classList.add("-zoomed");
        isZoomed = true;
      } else {
        scaleFactor = 1;
        zoomedImage.style.transform = "scale(1)";
        zoomedImage.classList.remove("-zoomed");
        isZoomed = false;
      }
    });

    // Move a imagem com o mouse no segundo nível de zoom
    imgContainer.addEventListener("mousemove", (event) => {
      if (isZoomed) {
        handleMouseMoveZoom(event, imgContainer, zoomedImage);
      }
    });
  },

  init: function () {
    const {
      setImages,
      setZoomControl,
      setHoverZoom,
      setThumbsControl,
      handleImagesPopup,
    } = Product;
    setProductTabs();
    setGallery(Product);
    setImages();

    setZoomControl();

    if (!window.mobile) {
      setHoverZoom();
      setThumbsControl();
      handleImagesPopup();
    }

    setRelatedModelsCarousel();
    setPopupSizes();
    setCarousel();
    setTopBar();
    formMasks();
  },
};

window.addEventListener("DOMContentLoaded", () => {
  Product.init();
});
